"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setItem = exports.rmItem = exports.getItemJSON = exports.getItem = void 0;
var _GeneralError = _interopRequireDefault(require("./error/GeneralError.js"));
var _errorCode = require("./error/error-code.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getItem = function getItem(cacheName) {
  return sessionStorage.getItem(cacheName);
};
exports.getItem = getItem;
var getItemJSON = function getItemJSON(cacheName) {
  try {
    var value = getItem(cacheName);
    if (value) {
      return JSON.parse(value);
    }
  } catch (err) {
    console.error('Error processing session value: ', err);
    throw new _GeneralError["default"](_errorCode.GENERAL, 'Session storage value corrupted');
  }
  return undefined;
};
exports.getItemJSON = getItemJSON;
var setItem = function setItem(cacheName) {
  return function (value) {
    sessionStorage.setItem(cacheName, value);
    return undefined;
  };
};
exports.setItem = setItem;
var rmItem = function rmItem(cacheName) {
  sessionStorage.removeItem(cacheName);
  return undefined;
};
exports.rmItem = rmItem;